import { USER_LOGOUT } from './general.types';

export function logout(payload) {
  return {
    type: USER_LOGOUT,
    payload,
  };
}